import React, { HTMLAttributes } from 'react';
import { observer } from 'mobx-react-lite';
import { StyledSelect } from './category-select.styled';

export type Props = {
    isSelected: boolean;
    isDisabled?: boolean;
} & HTMLAttributes<HTMLDivElement>;

export const CategorySelect = observer(
    ({ children, ...props }: Props) => {
        return <StyledSelect {...props}>{children}</StyledSelect>;
    }
);
